const PLUS_SALE_CHANNEL = 107;

function withPlusChannel(params = {}) {
  return Object.assign({}, params, { SaleChannel: PLUS_SALE_CHANNEL });
}

function plusFetch(actiontype, params) {
  return this.fetch(actiontype, withPlusChannel(params), 'plusChannel');
}

export default {
  // 产品类型配置
  async plusCardSaleToC_selectAllType(params) {
    return await plusFetch.call(this, 'plusCardSaleToC_selectAllType', params);
  },
  // plus介绍页面
  async plusCardSaleToC_plusToCSaleList(params) {
    return await plusFetch.call(this, 'plusCardSaleToC_plusToCSaleListNew', params);
  },
  // plus介绍页面（按卡种查询）
  async selectToCSaleListByCardType(params) {
    return await plusFetch.call(this, '/plusCardSaleToC/selectToCSaleListByCardType', params);
  },
  // plus介绍页面（按销售策略查询单卡）
  async plusCardSaleToC_selectSaleInfoByTid(params) {
    return await plusFetch.call(this, 'plusCardSaleToC_selectSaleInfoByTid', params);
  },
  // 产品开卡
  async createPlusCardOrder(params) {
    return await plusFetch.call(this, 'OrderService_createPlusCardOrder', params);
  },
  // plus订单详情
  async plusCardSaleToC_plusToCOrderInfo(params) {
    return await plusFetch.call(this, 'plusCardSaleToC_plusToCOrderInfo', params);
  },
  // 查询是否重复购买
  async checkIfHavePlusCard(params) {
    return await plusFetch.call(this, 'checkIfHavePlusCard', params);
  },
  // 创建退单
  async createPlusRefundOrder(params) {
    return await plusFetch.call(this, 'createPlusRefundOrder', params);
  },
  // 取消订单
  async cancelOrder(params) {
    return await plusFetch.call(this, 'OrderService_OrderCancelHandler', params);
  },
  // 全部服务订单列表
  async getUnionOrderList(params) {
    return await plusFetch.call(this, 'getUnionOrderList', params);
  },
  // 获取支付链接
  async plusGetPayUrl(params) {
    return await plusFetch.call(this, 'OrderService_GetPayUrlHandler', params);
  },
  // 0元支付确认
  async plusConfirmZeroPay(params) {
    return await plusFetch.call(this, 'OrderService_ChangePayStatus', params);
  },
  // 获取用户信息（中行 PLUS 渠道）
  async getPlusUserInfo(params = {}) {
    const actiontype = '/user/client/user/info';
    return await this.fetch(actiontype, withPlusChannel(params), 'bocChannel');
  },
};



// WEBPACK FOOTER //
// ./src/interfaces/modules/plus.js